import React from 'react';
import ProjectCard from './ProjectCard';

/**
 * ProjectCardList Component
 * Grid/list of project cards for mobile view
 * Cards are standalone with visual separation
 */
export default function ProjectCardList({ projects, emptyMessage = 'No projects found' }) {
  if (!projects || projects.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500 bg-white rounded-lg border border-gray-200">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {projects.map(project => (
        <ProjectCard key={project.id} project={project} />
      ))}
    </div>
  );
}
